import React, { useState } from "react";
import {
  Regions,
  type ComponentProps,
  type PageData,
} from "@enonic/react-components";

import "./default.scss";

import HageHeader from "/react4xp/components/shared/HageHeader/HageHeader";
import HageMenu from "/react4xp/components/shared/HageMenu/HageMenu";
import HageBreadcrumbs from "/react4xp/components/shared/HageBreadcrumbs/HageBreadcrumbs";
import Footer from "/react4xp/components/shared/Footer/Footer";

import type { PageComponentProps } from "./default.d";

export const defaultPage = ({
  data,
  common,
  meta,
  component,
}: ComponentProps<PageData>) => {
  const {
    linkLogo,
    thema,

    menu,

    footerPhone,
    footerMapLinkTitle,
    footerMapLinkUrl,
    footerMapLinkType,
    showSubscribeForm,
    privacyLinkSubscribeFormUrl,
    subscriptionLinkSubscribeFormUrl,
    titleContactUsLinks,
    contactUsLinks,
    titleAboutUsLinks,
    aboutUsLinks,
    socialMedia,
    linkYellowUrl,
    linkYellowShow,
    linkYellowTitle,
    linkYellowType,
    linkDiakonhjemmetHageUrl,
    linkDiakonhjemmetHageTitle,
    linkDiakonhjemmetHageType,
    linkDiakonhjemmetHageShow,
    breadcrumbs = [],
  } = (data.propsPage as PageComponentProps) ?? {};

  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <HageHeader
        homeUrl={linkLogo}
        menuOpen={menuOpen}
        onMenuToggle={() => setMenuOpen((v) => !v)}
      />

      <HageMenu
        menu={menu}
        isOpen={menuOpen}
        onClose={() => setMenuOpen(false)}
        homeUrl={linkLogo}
      />

      {breadcrumbs.length > 0 && <HageBreadcrumbs items={breadcrumbs} />}

      <Regions common={common} meta={meta} component={component} />

      <Footer
        phone={footerPhone}
        mapLinkTitle={footerMapLinkTitle}
        mapLinkUrl={footerMapLinkUrl}
        mapLinkType={footerMapLinkType}
        showSubscribeForm={showSubscribeForm}
        privacyLinkSubscribeFormUrl={privacyLinkSubscribeFormUrl}
        subscriptionLinkSubscribeFormUrl={subscriptionLinkSubscribeFormUrl}
        titleContactUsLinks={titleContactUsLinks}
        contactUsLinks={contactUsLinks}
        titleAboutUsLinks={titleAboutUsLinks}
        aboutUsLinks={aboutUsLinks}
        socialMedia={socialMedia}
        linkYellowUrl={linkYellowUrl}
        linkYellowTitle={linkYellowTitle}
        linkYellowType={linkYellowType}
        linkYellowShow={linkYellowShow}
        linkDiakonhjemmetHageUrl={linkDiakonhjemmetHageUrl}
        linkDiakonhjemmetHageTitle={linkDiakonhjemmetHageTitle}
        linkDiakonhjemmetHageType={linkDiakonhjemmetHageType}
        linkDiakonhjemmetHageShow={linkDiakonhjemmetHageShow}
        thema={thema}
      />
    </>
  );
};

defaultPage.displayName = "Page";
export default defaultPage;
